
import "@babel/polyfill";
import { polyfill } from 'es6-promise'; polyfill();
import "isomorphic-fetch";

import SaveForm from '../vendor/vsf/forms/js/SaveForm';
import DeleteForm from '../vendor/vsf/forms/js/DeleteForm';
import FormsLists from '../vendor/vsf/forms/js/FormsLists';
import AjaxAction from '../vendor/vsf/forms/js/AjaxAction';
import Util from '../vendor/vsf/forms/js/Util';

import Login from '../vendor/vsf/advanced-login/js/Login';
import ScreenOnSessionExpired from '../vendor/vsf/advanced-login/js/ScreenOnSessionExpired';
import RememberPassword from '../vendor/vsf/advanced-login/js/RememberPassword';
import RememberChangePassword from '../vendor/vsf/advanced-login/js/RememberChangePassword';

// Asigno al namespace global "window" lo que necesito para que se llame en las páginas de la aplicación
window.SaveForm=SaveForm;
window.DeleteForm=DeleteForm;
window.FormsLists=FormsLists;
window.AjaxAction = AjaxAction;
window.Util = Util;

window.Login = Login;
window.ScreenOnSessionExpired = ScreenOnSessionExpired;
window.RememberPassword = RememberPassword;
window.RememberChangePassword = RememberChangePassword;

//Funciones comunes
window.windowResize = function(){
    if($(window).width()<768){
        $('body').addClass('sidebar-minimized');
    }else{
        $('body').removeClass('sidebar-minimized');
    }
}

window.ajaxAction = new AjaxAction();
window.ajaxAction.initEvents();

$(function() {

    /**
     * Funcion que guarda en el localStorage el estado del sidebar (plegado o oculto)
     */
    function storageSaveHeaderSidebar(){
        if(typeof(Storage) !== "undefined"){
            if($('body').hasClass("sidebar-minimized")){
                localStorage.setItem("sidebar-body-class", "sidebar-minimized");

            }else if($('body').hasClass("sidebar-hidden")){
                localStorage.setItem("sidebar-body-class", "sidebar-hidden");

            }else{
                localStorage.removeItem("sidebar-body-class");
            }
        }
    }

    /**
     * Carga el estado del header y sidebar (plegado o oculto), guardado en el localStorage
     */
    function storageLoadHeaderSidebar(){
        if(typeof(Storage) !== "undefined"){
            var cssClass = localStorage.getItem("sidebar-body-class");
            //console.log("sidebar-body-class: "+cssClass);
            if(cssClass!==null && cssClass!==undefined && cssClass!==""){
                $('body').addClass(cssClass);
            }
        }
    }

    $(".header-toggler").click(function(){
        $('body').removeClass('header-minimized').toggleClass('header-hidden');
        storageSaveHeaderSidebar();
    });
    $(".sidebar-toggler").click(function(){
        $('body').removeClass('sidebar-minimized').toggleClass('sidebar-hidden');
        storageSaveHeaderSidebar();
    });

    $(".header-minimizer").click(function(){
        $('body').removeClass('header-hidden').toggleClass('header-minimized');
        storageSaveHeaderSidebar();
    });
    $(".sidebar-minimizer").click(function(){
        $('body').removeClass('sidebar-hidden').toggleClass('sidebar-minimized');
        storageSaveHeaderSidebar();
    });

    $(".sidebar .nav-dropdown-toggle").click(function(){
        $(this).closest('.nav-dropdown').toggleClass('open');
        return false;
    });

    $(window).resize(function() {
        windowResize();
    });
    windowResize();
    storageLoadHeaderSidebar();

    //Desglosa el menu del link activo
    $(".sidebar .nav-link.active").parents('.nav-dropdown').find('> .nav-dropdown-toggle').click();

    //select2
    $("select:not(.no-select2)").select2({
        theme: "bootstrap",
        minimumResultsForSearch: 6
    });

});
